import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

type ProductShareLinksSX = {
	contentCopyIcon: SxProps<Theme>;
	linkIcon: SxProps<Theme>;
	productShareLinksContainer: SxProps<Theme>;
	shareIcon: SxProps<Theme>;
	alignShareItem: SxProps<Theme>;
	iconsContainerDesktop: SxProps<Theme>;
	iconsContainerMobile: SxProps<Theme>;
	iconContainer: SxProps<Theme>;
};

export const productShareLinksSX: ProductShareLinksSX = {
	contentCopyIcon: {
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
	},
	linkIcon: {
		marginRight: '8px',
		color: 'text.alert',
	},
	productShareLinksContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '15px',
		padding: {
			xs: '10px',
			sm: '10px',
			md: '20px',
			lg: '20px',
			xl: '20px',
		},
		height: {
			xs: '396px',
			sm: '396px',
			md: '796px',
			lg: '796px',
			xl: '796px',
		},
	},
	shareIcon: {
		display: 'flex',
		alignSelf: 'center',
		fontSize: '48px',
	},
	alignShareItem: {
		display: 'flex',
		alignSelf: 'center',
		fontWeight: OpenSansFontWeights.light,
		color: 'grey.500',
	},
	iconsContainerDesktop: {
		display: 'flex',
		alignItems: 'center',
		gap: '15px',
		alignSelf: 'center',
	},
	iconsContainerMobile: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: '15px',
		alignSelf: 'center',
	},
	iconContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '3px',
		cursor: 'pointer',
	},
};
